export class TipoOperacion {
  public static ENTRADA = "ENTRADA";
  public static SALIDA = "SALIDA";
  public static ACTUALIZACION = "ACTUALIZACION";
}
